// React
import { useTranslation } from 'react-i18next';

// Libs
import { Card, Table } from 'semantic-ui-react';

// Components
import CopyContentComponent from '../../../misc/CopyContent.component';

// Services
import dateToString from '../../../../services/misc/dateToString';

// Types
import { customerState } from '../../../../model/details/customer';
import { UserType } from '../../../../types/General';

type LeadCustomerComponentProps = {
    data: typeof customerState;
    type: UserType;
    copy?: boolean;
};

export default function LeadCustomerComponent(props: LeadCustomerComponentProps) {
    const { t } = useTranslation();

    const matrix = [
        // key of translation , key of value (currently app uses the same wording, but you can change it in the ACL)
        ['knownCustomer', 'knownCustomer'],
        ['title', 'title'],
        ['firstName', 'firstName'],
        ['lastName', 'lastName'],
        ['email', 'email'],
        ['mobilePhoneNumber', 'mobilePhoneNumber'],
        ['address', 'streetName', 'houseNumber'],
        ['addressAddition', 'addressAddition'],
        ['postalCode', 'postalCode'],
        ['city', 'city'],
        ['birthdate', 'birthdate'],
    ];

    if (props.type === 'PRIVATE') {
        matrix.push(['employedSince', 'employedSince']);
    }

    function createValue(values: Array<string>): React.ReactElement {
        const output = values.map((key) => {
            switch (key) {
                case 'birthdate':
                case 'employedSince':
                    return dateToString(props.data[key], 'dateShort') || '..';
                case 'knownCustomer':
                    return t(`lead.detail.box.customer.knownCustomerValue.${props.data[key]}`);
                default:
                    return props.data[key] + ' ';
            }
        });
        return props.copy ? <CopyContentComponent>{output.join(' ')}</CopyContentComponent> : <>{output}</>;
    }

    return (
        <Card fluid>
            <Card.Content>
                <Card.Header>{t(`lead.detail.box.customer.headline.${props.type}`)}</Card.Header>
                <Card.Description>
                    <Table celled striped columns={2}>
                        <Table.Body>
                            {matrix.map((row: Array<string>, ix) => (
                                <Table.Row key={ix}>
                                    <Table.Cell width={4}>{t(`lead.detail.box.customer.${row[0]}`)}</Table.Cell>
                                    <Table.Cell singleLine>{createValue(row.splice(1))}</Table.Cell>
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                </Card.Description>
            </Card.Content>
        </Card>
    );
}
